import ColorFlatUI from '../core/tools/colorflatui';
import environment from '../environment';
import Leaflet from './Leaflet';

class LocationLayer {
    constructor (currentMap) {

        const isAfterSales = environment.get('CONFIG.IS_AFTER_SALES');

        let url = `${environment.get('API_HOST')}/localidade/ObterLocalidade`;

        if (isAfterSales) {
            url = `${environment.get('API_HOST')}/aftersales/locales`;
        }

        return new Leaflet.GeoJSONLayer({
            map: currentMap,
            remote: {
                url: url,
                params: {
                    id: 0
                }
            },
            showAll: true,
            // autofocus: true,
            uniqueField: 'Id',
            symbology: {
                type: 'single',
                style: {
                    icon: {
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_highlight.png`,
                        iconSize: [50, 64], // size of the icon
                        iconAnchor: [25, 60] // point of the icon which will correspond to marker's location
                    },
                    clickable: false,
                    lineJoin: 'round',
                    color: ColorFlatUI.wet_asphalt[1][0],
                    fillOpacity: 0,
                    opacity: 0.8,
                    weight: 4
                }
            }
        });
    }
}

export default LocationLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/LocationLayer.js